import React, { useEffect, useState } from "react";
import './order-details.scss'
import { Row, Col, Space, Divider, Spin, List, Button, notification } from "antd";
import cashImage from '../../assets/images/order-details-cashicon.svg';
import rightArrow from '../../assets/images/order-details-rightArrow.svg';
import driverImage from '../../assets/images/order-details-driver.svg';
import truck from '../../assets/images/order-details-truck.svg';
import forwardArrow from '../../assets/images/orders-details-ForwardArrow.svg';
import leftarrowC from '../../assets/images/order-details-leftarrow.svg';
import rightarrowC from '../../assets/images/order-details-rightarrowC.svg';
import truckem from '../../assets/images/order-details-truckem.svg';
import scheduleArrow from '../../assets/images/order-details-schedule.svg';
import rightArrowSm from '../../assets/images/order-details-right-arrow-sm.svg';
import ArrowUp from '../../assets/images/arrow-up-order.svg';
import ArrowDown from '../../assets/images/arrow-down-order.svg';
import * as orderService from "../../service/order/orderService";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import InforCircle from "../../assets/images/information-circle.svg";
import PendingUploadd from "../../assets/images/orders-document-attachment.svg";
import rejectDocument from "../../assets/images/orders-document-attachment.svg";
import DecimalFormatter from "../../common/decimal-converter/decimal-converter";
import { checkIsInternalSourcing, checkIsTurkeyKazak, maskPhoneNumber } from "../../util/constantUtility";
import { useStore } from "../../store/store";
import rejectedInfoIcon from '../../assets/images/info-rejected.svg';
import doubleFill from '../../assets/images/check-double-fill.svg';
import documentIcon from '../../assets/images/document-attachment.svg';
import { t } from "i18next";
import VircleCircleImage from "../../assets/images/view-route-circle.svg";
import { useLocation } from "react-router-dom";
import * as localStorageService from "../../service/localStorageService";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import { CommonConstants } from "../../constants/commonConstants";
import { saveAnalyticalData } from '../../util/analyticalUtility';
import { useSelector } from "react-redux";
import { BrandColors } from "../../constants/brand";

const OrdersDetails = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentAlert, setCurrentAlert] = useState(0);
    const [orderDetails, setOrderDetails] = useState(null);
    const navigate = useNavigate();
    let { orderId } = useParams();
    const [loader, setLoader] = useState(false);
    const [scheduleAccordian, setScheduleAccordian] = useState(false);
    const [alert, setAlert] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [activeTripAlertIndex, setActiveTripAlertIndexAlert] = useState({});
    const [viewRoutes, setViewRoutes] = useState(false);
    const navigationTimer = 10000;
    const { user } = useStore();
    const [fromAddress, setFromAddress] = useState({});
    const [toAddress, setToAddress] = useState({});
    const dropLocations = orderDetails?.routePoints?.filter((item) => item.isPickup === false)
const isAISuggestion = useLocation().search.replace("?", "") === "true";

    useEffect(() => {
        const intervalId = setInterval(() => {
            setActiveTripAlertIndexAlert((prev) => {
                const newItem = { ...prev };
                orderDetails?.trips?.forEach((item) => {
                    const key = String(item.externalId);
                    const currentIndex = newItem[key] || 0;

                    if (item?.alerts?.length > 0) {
                        newItem[key] =
                            currentIndex < item.alerts.length - 1 ? currentIndex + 1 : 0;
                    }
                });
                return newItem;
            });
        }, navigationTimer);

        return () => clearInterval(intervalId);
    }, [orderDetails]);

    useEffect(() => {
        getOrderDetails();
    }, [])

    const getOrderDetails = () => {
        const languageISOCode=localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
        setLoader(true)
        orderService.getOrderDetails(orderId,languageISOCode)
            .then((res) => {
                if (res.status === 200) {
                    setLoader(false)
                    setOrderDetails(res?.data?.data)
                    setFromAddress(res?.data?.data?.fromAddress);
                    setToAddress(res?.data?.data?.toAddress);
                    saveAnalyticalData(
                    "ORDER_DETAILS_OPEN",
                    "Order Details Opened",
                    `Order ID: ${orderId}`,
                    user
                );
                }
            })
            .catch((err) => {

            })
    }

    const nextNotification = () => {
        if (currentIndex < notifications.length - 1) {
            setCurrentIndex(currentIndex + 1);
        } else {
            setCurrentIndex(0);  // Loop back to the first notification
        }
    };
    const nextAlert = () => {
        if (currentAlert < alert.length - 1) {
            setCurrentAlert(currentAlert + 1);
        }
        else {
            setCurrentAlert(0);  // Loop back to the first alert
        }
    };



    const TripsAlertNav = (direction, item) => {
        const key = String(item.externalId);
        setActiveTripAlertIndexAlert((prev) => {
            const currentIndex = prev[key] || 0;
            const totalAlerts = item?.alerts.length;
            let newIndex;

            if (direction === "right") {
                newIndex = currentIndex < totalAlerts - 1 ? currentIndex + 1 : 0;
            }
            else {
                newIndex = currentIndex > 0 ? currentIndex - 1 : totalAlerts - 1;
            }

            return {
                ...prev,
                [key]: newIndex,
            };
        });
    };

    // Distance Calculation
    function calculateDistance(lat1, lon1, lat2, lon2) {
        const toRadians = (degree) => (degree * Math.PI) / 180;
        const R = 6371;

        const dLat = toRadians(lat2 - lat1);
        const dLon = toRadians(lon2 - lon1);

        const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
            Math.sin(dLon / 2) ** 2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // Distance in kilometers
    }

    function formatDistanceInMiles(lat1, lon1, lat2, lon2) {
        const distanceInKm = calculateDistance(lat1, lon1, lat2, lon2);
        const distanceInMiles = distanceInKm * 0.621371; // Convert km to miles
        return `${distanceInMiles.toFixed(1)} mi`;
    }
    const handleRouteClick = ({ routePoints, fromAddress, toAddress }) => {
        const newTab = window.open('', '_blank');
        const script = newTab.document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAzDE3Ghsd_mbNCvehA2Yl25TrBqLD7_EU&libraries=places";
        script.onload = () => {
          const map = newTab.document.createElement('div');
          newTab.document.body.appendChild(map);
          map.style.width = "100vw";
          map.style.height = "100vh";
          map.style.margin = "0";
    
          const infoDiv = newTab.document.createElement('div');
          infoDiv.style.position = "absolute";
          infoDiv.style.top = "10px";
          infoDiv.style.left = "50%";
          infoDiv.style.transform = "translateX(-50%)";
          infoDiv.style.padding = "10px";
          infoDiv.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
          infoDiv.style.color = "white";
          infoDiv.style.fontSize = "16px";
          infoDiv.style.borderRadius = "5px";
          newTab.document.body.appendChild(infoDiv);
    
          const mapInstance = new newTab.google.maps.Map(map, {
            // center: { lat: pickupLat, lng: pickupLng },
            center: { lat: fromAddress?.latitude || routePoints[0]?.location?.latitude, lng: fromAddress?.longitude || routePoints[0]?.location?.longitude },
            zoom: 7,
          });
    
          const directionsService = new newTab.google.maps.DirectionsService();
          const directionsRenderer = new newTab.google.maps.DirectionsRenderer({
            polylineOptions: {
              strokeColor: BrandColors.primary,
              strokeWeight: 5,
              strokeOpacity: 1.0,
            }
          });
          directionsRenderer.setMap(mapInstance);
    
          let request;
    
          if (routePoints && routePoints.length > 0) {
    
            let waypoints = routePoints
              .filter((point) => !point.isPickup ) 
            //   .slice(1, -1)
              .map((point) => ({
                location: { lat: point?.location.latitude, lng: point?.location.longitude },
                stopover: true,
              }));

              
            request = {
              origin: { lat: routePoints[0]?.location?.latitude, lng: routePoints[0]?.location?.longitude }, 
              destination: { lat: routePoints[routePoints.length - 1]?.location?.latitude, lng: routePoints[routePoints.length - 1]?.location?.longitude }, 
              waypoints: waypoints,
              travelMode: newTab.google.maps.TravelMode.DRIVING,
            };
          } 
          else {
            request = {
              origin: { lat: fromAddress?.latitude, lng: fromAddress?.longitude },
              destination: { lat: toAddress?.latitude, lng: toAddress?.longitude },
              travelMode: newTab.google.maps.TravelMode.DRIVING,
            };
          }
    
          directionsService.route(request, (result, status) => {
                if (status === newTab.google.maps.DirectionsStatus.OK) {
                    directionsRenderer.setDirections(result);
                    const route = result.routes[0].legs[0];
                    const distance = route.distance.text;
                    const duration = route.duration.text;
                    infoDiv.innerHTML = `Distance: ${distance} <br> Duration: ${duration}`;
                } 
                else {
                    alert("Directions request failed due to " + status);
                }
          });
    
          routePoints.forEach((point) => {
            const marker = new newTab.google.maps.Marker({
              position: { lat: point.location.latitude, lng: point.location.longitude },
              map: mapInstance,
              title: point.location.address,
            });
          });
        }
    
        newTab.document.head.appendChild(script);
    };

    return (
        <div className="order-details-wrapper">
            <Row >
                {/* left side layout */}
                <Col span={16} className="left-side-order-container">
                    {/* Notification content */}
                    {orderDetails?.alerts?.length > 0 &&
                        <div className="card-notify">
                            <div>
                                <span className="message-content">
                                    <span className="notification-image">
                                        <img className="img-notify" src={cashImage} alt="Notification" />
                                        <span className="notification-content">
                                            <strong> {orderDetails?.alerts[currentIndex]?.message}</strong>
                                        </span>
                                    </span>

                                    {/* Right arrow */}
                                    <span className="right-arrow" onClick={nextNotification}>
                                        <span className="crousel-index">
                                            {Array(orderDetails?.alerts?.length).fill().map((_, index) => (
                                                <div key={index} className={`indicator-${index === 0 ? 'oval' : 'circle'} ${currentAlert === index + 1 ? 'active' : ''}`}></div>
                                            ))}
                                        </span>
                                        {orderDetails?.alerts?.length > 0 && <img src={rightArrow} />}
                                    </span>
                                </span>
                            </div>
                        </div>
                    }

                    <div className="card-col">
                        {loader ?(
                            <div className="loader">
                                <Spin />
                            </div>
                        ): 
                           (<>
                            <div>
                                 {orderDetails?.paymentBanner!==null && 
                                      <div className="payment-alert">{orderDetails?.paymentBanner}</div>
                                        }  <br/> 
                                </div> 
                             {orderDetails?.trips?.map((item, index) => (
                                <div className="cards" key={index} onClick={() => { }}>
                                    <div className="card-div-container">
                                       
                                    <Row justify={"space-between"} className="cards-row">
                                            <Space align={"center"} className="space-container-firstrow">
                                                <span className="truck-row"> {t("FLEET_TRUCKS_TRUCK_NO")}&nbsp;<strong>{item.assetRegistrationNumber}</strong></span>
                                                <span className={`status-row ${item.paymentStatus === 'completed' ? 'completed' : 'pending'}`}>
                                                    <strong> 
                                                    {/* {item.status} */}
                                                    {item?.localizeStatusName ? item?.localizeStatusName:item?.status}
                                                    </strong>
                                                </span>
                                            </Space>
                                        </Row>
                                        <Row >
                                            <Col align={"center"} className="col-container-second" span={8}>
                                            {!orderDetails?.isSTOServingAsDriver && 
                                                <div className="earning-row">
                                                    {Array.isArray(item.tripTotalCost) ? item.tripTotalCost.map((items, index) => (
                                                        <strong className="earning">
                                                            {items?.currency} {" "}
                                                            {items.amount ? <DecimalFormatter amount={items?.amount} country={checkIsTurkeyKazak(orderDetails?.operatingCountry) ? "TRY" : items.currency} flag={false} isShowDecimal={true}/> : 0}
                                                            {index < item.tripTotalCost.length - 1 && " + "}
                                                        </strong>
                                                    ))
                                                    :
                                                        <strong className="earning">
                                                            {item?.currency} {" "}
                                                            {item.tripTotalCost ? <DecimalFormatter amount={item?.tripTotalCost} country={checkIsTurkeyKazak(orderDetails?.operatingCountry) ? "TRY" : item.currency} flag={false} isShowDecimal={true}/> : 0}
                                                        </strong> 
                                                    }
                                                    {t("HOME_TOTAL_EARNINGS")}
                                                </div>
                                                    }
                                                <div className="date-info"><span className="ETA">ETA</span>
                                                    <span className="date-time">
                                                        <strong>
                                                            {item?.etaDate ? moment.utc(item?.etaDate).format("DD MMM YYYY, h:mm A") : "-"}
                                                        </strong>
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col span={8} className="driver-row">
                                                <div >
                                                    <div className="driver-info">
                                                        <img src={driverImage} alt="driver" />
                                                        <strong className="driver-name">{item.driverName}</strong>
                                                    </div>
                                                    <span className="driver-contact">+{item?.driverContactDetails?.countryCode} {item?.driverContactDetails?.mobileNumber}</span>
                                                </div>
                                                <div className="truckType-info"><img src={truck} /><strong >{orderDetails?.assetCategory}
                                                    <span className="sub-truck-type">{orderDetails?.assetSubType}</span>
                                                </strong> 
                                                 {(orderDetails?.temperatureValue!==0 && orderDetails?.temperatureValue!== null) && 
                                     <span className={orderDetails?.temperatureValue < 0 ? 'cold-temp' : 'hot-temp'}>{orderDetails?.temperatureValue>0 && '+' }{orderDetails?.temperatureValue} °C</span>} 
                                                </div>
                                            </Col>

                                            <Col className="col-container-btn" span={8}>
                                                {item?.tokenNumber && <div className="token-no">
                                                    <img src={InforCircle} alt="" />
                                                    <span>{t("ORDER_TOKEN_NO")}: <span className="token-number">{item?.tokenNumber}</span></span>
                                                </div>}
                                                <button
  className="Document-Button"
  onClick={async () => {
    saveAnalyticalData(
      "TRIP_STATUS_CHANGE ",      
      "Trip Status Changed", 
      user.userName || "",   
      user                   
    );
    navigate(
      `/orders/${orderId}/${item?.externalId}/${item?.assetRegistrationNumber}-${item?.driverName}?${isAISuggestion}`
    );
  }}
>
  {t("ORDER_STATUS/DOC_UPDATE")}
  <img src={forwardArrow} alt="->" />
</button>

                                            </Col>
                                        </Row>

                                        {item?.alerts.length > 0 && <div className="card-alert">
                                            <div className="alert-layout">
                                                <div className="card-alert-div">
                                                    <div className="alert-content">
                                                        <span>
                                                            <img src={item.alerts[currentAlert]?.message.includes('pending') ? PendingUploadd : rejectDocument} alt="" />
                                                        </span>
                                                        <span className="alert-notification"><strong>{alert[currentAlert]?.message}</strong>
                                                            <span>{item?.alerts[activeTripAlertIndex[item.externalId] || 0]?.message}</span>

                                                        </span>
                                                    </div>
                                                </div>
                                                {/* {item?.alerts.length > 1 && */}
                                                <div className="direction-arrow">
                                                    <img src={leftarrowC} onClick={() => TripsAlertNav('left', item)} />
                                                    <img src={rightarrowC} onClick={() => TripsAlertNav('right', item)} />
                                                </div>
                                                {/* } */}
                                            </div>

                                            <div className="indicator-container">

                                                {Array(item?.alerts.length).fill().map((_, index) => (
                                                    <div key={index} className={`indicator-${index === 0 ? 'oval' : 'circle'} ${currentAlert === index + 1 ? 'active' : ''}`}></div>
                                                ))}

                                            </div>

                                        </div>
                                        }
                                    </div>
                                    <Divider style={{ margin: 0, borderColor: 'var(--border, #EBEBEB)', borderWidth: '5px' }} className="bottom-divider" />
                                </div>
                            ))}
                           </>)
                            }
                    </div>

                </Col>
                {/* right side layout */}
                <Col span={8} className="right-col-container">
                    <div className="right-alert">
                        <span className="alert-title"><strong>{t("MYBIDS_ALERTS")}</strong></span>
                        {orderDetails?.alertDetails?.alerts?.length > 0 ? orderDetails?.alertDetails?.alerts?.map((item, index) => (
                            <div key={index} className={`alert-bar ${item.type || ''}`}>
                                <span className="alert-content">
                                    <span>{item.type === "Warning" ? <img src={documentIcon} /> : item.type === "Rejected" ? <img src={rejectedInfoIcon} /> : <img src={doubleFill} />}</span>
                                    <span dangerouslySetInnerHTML={{ __html: item.message.replace(/"([^"]*)"/g, '<strong>$1</strong>') }} />
                                    {/* <span><img src={rightArrowSm} alt="->" /></span> */}
                                </span>
                            </div>
                        ))
                            :
                            <div className="no-data">{t("ORDER_NO_ALERTS")}</div>
                        }
                    </div>
                    <div className="right-schedule">
                        <div className="right-schedule-firstrow">
                            <span className="Schedule-title"><strong>{t("MYBIDS_SCHEDULE")}</strong></span>
                            <span className="right-schedule-datetime">
                                <span>{moment.utc(orderDetails?.moveDate).format("DD MMM YYYY, h:mm A") || "-"}</span>
                                <span>{orderDetails?.moveType} - {orderDetails?.operationType}</span>
                            </span>
                        </div>
                    <div class="pickup-drop-container">
                        {viewRoutes ? 
                            <> 
                                {orderDetails?.routePoints?.filter((item) => item.isPickup === true)?.map((item, index) => (
                                    <div class="source-item">
                                        <div class={item.sequence === 1 && index === 0 ? "icon-circle" : "icon-circle1"}></div>
                                        <div class="content">
                                            {(item.sequence === 1 && index === 0) && <span class="label1">{t("LOADS_PICKUP")}</span>}
                                            <div className={(item.sequence === 1 && index === 0) ? "location" : "view-location"}>{item.location.address}</div>
                                           {(item.sequence === 1 && index === 0) ? null : <div style={{marginTop:"0.1rem",fontSize:'10px'}}>
                                            <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>Loading Contact:</span>
                                            <div>{item?.location?.contactName}</div>
                                            </div>}
                                        </div>
                                    </div> 
                                ))}
                            </>
                        :
                            <div class="source-item">
                                <div class="icon-circle"></div>
                                <div class="content">
                                    <span class="label1">{t("LOADS_PICKUP")}</span> 
                                    <div class="location">{orderDetails?.fromAddress?.location}</div>
                                    <div>
                                        <Row>
                                    <Col span={11}>
                                    <div style={{marginTop:"0.1rem",fontSize:'10px'}}>
                                    <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>Loading Contact:</span>
                                    <div>{orderDetails?.loadingContact?.name}</div>
                                    </div>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span={12}>
                                    <div style={{marginTop:"0.1rem"}}>
                                        <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>{t("BIDS_ORIGIN_CLEARING_AGENT_LB")}:</span>
                                        <div style={{fontSize:'10px'}}>
                                        {orderDetails?.clearingAgentContact ?
                                            <span>
                                            {orderDetails?.clearingAgentContact?.name}
                                            <br />
                                            {orderDetails?.clearingAgentContact?.countryCode}&nbsp;
                                            {checkIsInternalSourcing(user?.userRole) ? orderDetails?.clearingAgentContact?.mobileNumber:maskPhoneNumber(orderDetails?.clearingAgentContact?.mobileNumber)}
                                            </span> : "-"}
                                        </div>
                                        </div>
                                    </Col>
                                </Row>
                                    </div>
                                </div>
                            </div> 
                        }  

                        <div class="source-item">
                            <div class="content">
                                {orderDetails?.routePoints?.length > 2 &&
                                    <div class="view-pickups-drops" onClick={() => setViewRoutes(!viewRoutes)}>
                                        <span>{viewRoutes ? t("HIDE_PICKUPS_DROPS") : t("VIEW_PICKUPS_DROPS")}</span>
                                        <img src={VircleCircleImage} alt='' /> 
                                    </div>
                                }
                            </div>
                        </div> 

                        <span className="pickup-miles">
                            <span className="pickup-title">
                                {formatDistanceInMiles(
                                    orderDetails?.fromAddress?.latitude,
                                    orderDetails?.fromAddress?.longitude,
                                    orderDetails?.toAddress?.latitude,
                                    orderDetails?.toAddress?.longitude
                                )}
                            </span>
                        </span>
                                                                      
                        <div class="line"></div>

                        {viewRoutes ? 
                            <> 
                                <div class="destination-item">
                                    <div class="content" style={{ marginLeft: "20px" }}>
                                        <span class="label1">{t("LOADS_DROP")}</span>
                                    </div>
                                </div>

                                {dropLocations?.map((item, index) => (
                                    index !== dropLocations.length - 1 && 
                                    <div class="destination-item">
                                        <div class="icon-square1"></div>
                                        <div class="content">
                                            <div className="view-location">{item.location.address}</div>
                                            <div style={{fontSize:'10px'}}>
                                            <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>Unloading Contact:</span>
                                           <div>{item.location.contactName}</div>
                                           <div>{item.location?.countryCallingCode } {checkIsInternalSourcing(user?.userRole) ? item.location?.contactNumber:maskPhoneNumber(item.location?.contactNumber)}</div>
                                            </div>
                                        </div>
                                    </div> 
                                ))}

                                <div class="destination-item">
                                    <div class="icon-square"></div>
                                    <div class="content">
                                        <div class="location1">
                                            <div>{dropLocations[dropLocations.length - 1]?.location?.address}</div>
                                            <Button className='view-route-btn' onClick={() =>
                                                handleRouteClick({
                                                    routePoints: orderDetails?.routePoints,
                                                    fromAddress: orderDetails?.fromAddress,
                                                    toAddress: orderDetails?.toAddress,
                                                })
                                            }>
                                                {t("LOADS_VIEW_ROUTE")}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        :
                            <div class="destination-item">
                                <div class="icon-square"></div>
                                <div class="content" >
                                      <span class="label1">{t("LOADS_DROP")}</span>
                                    <div class="location1">
                                        <div>
                                        {orderDetails?.routePoints?.length > 0 ? orderDetails?.routePoints[orderDetails?.routePoints.length - 1]?.location?.address : orderDetails?.toAddress?.location}</div>
                                        <Button className='view-route-btn' onClick={() =>
                                            handleRouteClick({
                                                routePoints: orderDetails?.routePoints,
                                                fromAddress: orderDetails?.fromAddress,
                                                toAddress: orderDetails?.toAddress,
                                            })
                                        }>
                                            {t("LOADS_VIEW_ROUTE")}
                                        </Button>
                                    </div>
                                    <div>
                                    <Row>
                                    <Col span={7}>
                                        <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>Unloading Contact:</span>
                                        <div style={{fontSize:'10px'}}>{orderDetails?.unLoadingContact?.name}</div>
                                        <div style={{fontSize:'10px'}}>{orderDetails?.unLoadingContact?.countryCode } {checkIsInternalSourcing(user?.userRole) ? orderDetails?.unLoadingContact?.mobileNumber:maskPhoneNumber(orderDetails?.unLoadingContact?.mobileNumber)}</div>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span={7}>
                                    <div style={{marginTop:"0.1rem"}}>
                                    <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>{t("BIDS_DESTINATION_CLEARING_AGENT_LB")}:</span>
                                    <div>
                                    {orderDetails?.destinationClearingAgentContact ?
                                        <span style={{fontSize:'10px'}}>
                                            {orderDetails?.destinationClearingAgentContact?.name}
                                            <br />
                                            {orderDetails?.destinationClearingAgentContact?.countryCode}&nbsp;
                                            {checkIsInternalSourcing(user?.userRole) ? orderDetails?.destinationClearingAgentContact?.mobileNumber:maskPhoneNumber(orderDetails?.destinationClearingAgentContact?.mobileNumber)}
                                        </span> : "-"}
                                    </div>
                                    </div>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span={7}>
                                <div style={{marginTop:"0.1rem"}}>
                                <span style={{color:"var(--text, rgba(41, 41, 41, 1))",fontSize:'10px'}}>{t("MYBIDS_CONSIGNEE_CONTACT")}:</span>
                                <div>
                                {orderDetails?.consigneeContact ?
                                    <span style={{fontSize:'10px'}}>
                                        {orderDetails?.consigneeContact?.name}
                                        <br />
                                        {orderDetails?.consigneeContact?.countryCode}&nbsp;
                                        {checkIsInternalSourcing(user?.userRole) ? orderDetails?.consigneeContact?.mobileNumber:maskPhoneNumber(orderDetails?.consigneeContact?.mobileNumber)}
                                    </span> : "-"}
                                </div>
                                </div>
                                    </Col>
                                    </Row>
                                    </div>
                                </div>
                            </div>
                        } 
                  </div>
                        {/* <Row className="schedule-direction">
                            <Col span={2} className="up-arrow">
                                <img src={scheduleArrow} alt="direction" />
                            </Col>
                            <Col span={14} className="pickup-container">
                                <span className="initial-pickup">
                                    <span className="pickup-title">{t("ORDER_PICK-UP")}</span>
                                    <span className="pickup-value">{orderDetails?.fromCity}</span>
                                </span>
                                <span className="pickup-miles">
                                    <span className="pickup-title">
                                        {formatDistanceInMiles(
                                            orderDetails?.fromAddress?.latitude,
                                            orderDetails?.fromAddress?.longitude,
                                            orderDetails?.toAddress?.latitude,
                                            orderDetails?.toAddress?.longitude
                                        )}
                                    </span>
                                </span>
                                <span className="final-destination">
                                    <span className="pickup-title">{t("MYBIDS_DROP")}</span>
                                    <span className="pickup-value">{orderDetails?.toCity}
                                    </span>
                                </span>
                            </Col>
                            <Col span={8}>
                                <button className="route-btn" onClick={() =>
                                    handleRouteClick({
                                        pickupLat: orderDetails?.fromAddress?.latitude,
                                        pickupLng: orderDetails?.fromAddress?.longitude,
                                        dropLat: orderDetails?.toAddress?.latitude,
                                        dropLng: orderDetails?.toAddress?.longitude,
                                    })
                                }>{t("MYBIDS_VIEW_ROUTE")}</button>
                            </Col>
                        </Row> */}
                        <Row className="contactInfo-scheduleCard">
                            <Row className="contactInformation-title">
                                {t("ORDER_CONTACT_INFO")} <span><img src={scheduleAccordian ? ArrowDown : ArrowUp} onClick={() => setScheduleAccordian(!scheduleAccordian)} /></span>
                            </Row>
                            <Row>
                                {
                                    scheduleAccordian &&
                                    <Row gutter={[16, 16]} className="contact-value-schedule">
                                        <Col span={12}>
                                            <div className="loading-contact-div-wrapper">
                                                <span className="contact-title">{t("ORDER_LOADING_CONTACT")}</span>
                                                <span className="contact-name">{orderDetails?.loadingContact?.name ? orderDetails?.loadingContact?.name : "-"}</span>
                                                <span className="contact-number">{checkIsInternalSourcing(user?.userRole) && orderDetails?.loadingContact?.mobileNumber? `${orderDetails?.loadingContact?.countryCode || ""} ${orderDetails.loadingContact.mobileNumber}`: "-"}
                                                </span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="loading-contact-div-wrapper">
                                                <span className="contact-title">{t("BIDS_ORIGIN_CLEARING_AGENT_LB")}</span>
                                                <span className="contact-name">{orderDetails?.clearingAgentContact?.name ? orderDetails?.clearingAgentContact?.name : "-"}</span>
                                                <span className="contact-number">{orderDetails?.clearingAgentContact?.mobileNumber ? (checkIsInternalSourcing(user?.userRole) ?  (`${orderDetails?.clearingAgentContact?.countryCode} ${orderDetails?.clearingAgentContact?.mobileNumber}`) : `${orderDetails?.clearingAgentContact?.countryCode} ${maskPhoneNumber(orderDetails?.clearingAgentContact?.mobileNumber)}`) : "-"}
                                                </span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="loading-contact-div-wrapper">
                                                <span className="contact-title">Unloading Contact</span>
                                                <span className="contact-name">{orderDetails?.unLoadingContact?.name ? orderDetails?.unLoadingContact?.name : "-"}</span>
                                                <span className="contact-number">{orderDetails?.unLoadingContact?.mobileNumber ? (checkIsInternalSourcing(user?.userRole) ?  (`${orderDetails?.unLoadingContact?.countryCode} ${orderDetails?.unLoadingContact?.mobileNumber}`) : `${orderDetails?.unLoadingContact?.countryCode} ${maskPhoneNumber(orderDetails?.unLoadingContact?.mobileNumber)}`) : "-"}
                                                </span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="loading-contact-div-wrapper">
                                                <span className="contact-title">Consignee Contact</span>
                                                <span className="contact-name">{orderDetails?.consigneeContact?.name ? orderDetails?.consigneeContact?.name : "-"}</span>
                                                <span className="contact-number">{orderDetails?.consigneeContact?.mobileNumber ? (checkIsInternalSourcing(user?.userRole) ?  (`${orderDetails?.consigneeContact?.countryCode} ${orderDetails?.consigneeContact?.mobileNumber}`) : `${orderDetails?.consigneeContact?.countryCode} ${maskPhoneNumber(orderDetails?.consigneeContact?.mobileNumber)}`) : "-"}
                                                </span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="loading-contact-div-wrapper">
                                                <span className="contact-title">{t("BIDS_DESTINATION_CLEARING_AGENT_LB")}</span>
                                                <span className="contact-name">{orderDetails?.destinationClearingAgentContact?.name || "-"}</span>
                                                <span className="contact-number">{orderDetails?.destinationClearingAgentContact?.mobileNumber ? (checkIsInternalSourcing(user?.userRole) ? (`${orderDetails?.destinationClearingAgentContact?.countryCode} ${orderDetails?.destinationClearingAgentContact?.mobileNumber}`):`${orderDetails?.destinationClearingAgentContact?.countryCode} ${maskPhoneNumber(orderDetails?.destinationClearingAgentContact?.mobileNumber)}`) : "-"}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </Row>

                        </Row>
                    </div>
                    <div className="right-load-details">
                        <div className="load-details">
                            <span><strong>{t("LOADS_DETAILS")}</strong></span>
                            <span className="load-details-datetime">
                                <span>{moment.utc(orderDetails?.moveDate).format("DD MMM YYYY, h:mm A") || "-"}</span>
                                <span>{orderDetails?.moveType} - {orderDetails?.operationType}</span>
                            </span>
                        </div>
                        <div className="load-details-truckrow">
                            <div className="load-details-truckrow-left">
                                <span><img src={truckem} /></span>
                                <span className="truck-type">{orderDetails?.assetCategory} - {orderDetails?.assetSubType}</span>
                                {/* <span className={orderDetails?.temperatureValue < 0 ? 'cold-temp' : 'hot-temp'}>{orderDetails?.temperatureValue>0 ? '+' : '-'}{orderDetails?.temperatureValue} {orderDetails?.temperatureType == 'Fahrenheit' ? '°F':'°C'}</span> */}
                                {(orderDetails?.temperatureValue!==0 && orderDetails?.temperatureValue!== null) && 
                          <span className={orderDetails?.temperatureValue < 0 ? 'cold-temp' : 'hot-temp'}>{orderDetails?.temperatureValue>0 && '+' }{orderDetails?.temperatureValue} °C</span>}
                            </div>
                            <div className="load-details-truckrow-right">
                                <span className="no-of-truck-title">{t("HOME_TRUCKS")}</span>
                                <span className="no-of-truck-value">{orderDetails?.noOfAssets}</span>
                                <span className="weight-of-truck-title">{t("ORDER_WEIGHT/TRUCK")}</span>
                                <span className="weight-of-truck-value">{orderDetails?.maxWeight}{orderDetails?.maxWeightUnits}</span>
                            </div>
                        </div>
                        <div className="commodity-details">
                            <span className="commodity">{t("LOADS_COMMODITY")}</span>
                            <span className="commodity-type">
                            {/* {orderDetails?.commodity} */}
                            {orderDetails?.localizeCommodityName ? orderDetails?.localizeCommodityName:orderDetails?.commodity}
                            </span>
                        </div>
                    </div>
                    <div className="right-load-details">
                        <div className="payments-details-row">
                            <span><strong>{t("ORDER_PAYMENT_DETAILS_LBL")}</strong></span>
                            <div>
                            {Array.isArray(orderDetails?.payments?.totalAmount) ? orderDetails?.payments?.totalAmount.map((items, index) => (
                                <span>
                                {t("PAYMENTS_TOTAL_AMT")}: <span className="green">{items?.currency} {items?.amount}</span>
                                </span>
                            ))
                            :
                                <span>
                                {t("PAYMENTS_TOTAL_AMT")}: <span className="green">{orderDetails?.currency} {orderDetails?.payments?.totalAmount}</span>
                                </span>
                            }

                            {Array.isArray(orderDetails?.payments?.totalAmountReceived) ? orderDetails?.payments?.totalAmountReceived.map((items, index) => (
                                <span>
                                {t("PAYMENTS_TOTAL_AMT_RECEIVED")}: <span className="green">{items?.currency} {items?.amount}</span>
                                </span>
                            ))
                            :
                                <span>
                                {t("PAYMENTS_TOTAL_AMT_RECEIVED")}: <span className="green">{orderDetails?.currency} {orderDetails?.payments?.totalAmountReceived}</span>
                                </span>
                            }
                            {Array.isArray(orderDetails?.payments?.totalAmountPending) ? orderDetails?.payments?.totalAmountPending.map((items, index) => (
                                <span>
                                {t("PAYMENTS_TOTAL_AMT_PENDING")}: <span className="red">{items?.currency} {items?.amount}</span>
                                </span>
                            ))
                            :
                                <span>
                                {t("PAYMENTS_TOTAL_AMT_PENDING")}: <span className="red">{orderDetails?.currency} {orderDetails?.payments?.totalAmountPending}</span>
                                </span>
                            }
                            </div>
                        </div>

                        {orderDetails?.payments?.histories?.length > 0 ?
                        <List
                            itemLayout="horizontal"
                            dataSource={orderDetails?.payments?.histories}
                            className="payment-list"
                            renderItem={(item) => (
                            <List.Item>
                                <List.Item.Meta
                                avatar={item.icon}
                                title={<span>{`Amount is credited to your ${item.method}.`}</span>}
                                description={
                                    <Space direction="vertical">
                                    <span strong>AED {item.amount}</span>
                                    <span type="secondary">{item.date}</span>
                                    </Space>
                                }
                                />
                                {/* <CheckCircleOutlined className="check-icon" /> */}
                            </List.Item>
                            )}
                        />
                        :
                        <div className="payment-list-no-data">{t("COMMON_NO_DATA")}</div>
                        }
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default OrdersDetails;
